import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  Heading,
  BaseIcon,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';
import { isImpersonate } from '@/modules/common/services/partner';
import { useRouter } from 'vue-router/composables';

enum ERiskGrade {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

interface IData {
  customerRiskProfile: {
    label: string;
    value: string;
  }[];
  requestRisksSignature: {
    formatted: {
      formatted: string;
      value: string;
    };
    label: string;
    productId: string;
  }[];
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
interface Props {
  isOpen: boolean;
  data: IData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RiskSignature',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'close'): void;
  (event: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  data: IData;
};

const router = useRouter();





const headingData = computed(() => {
  return isImpersonate()
    ? {
        title:
          'Não é possivel sugerir produtos fora do nível de risco do cliente',
        subtitle:
          'Sugira produtos para o cliente dentro do nível de risco indicado para o perfil de investimento do cliente.'
      }
    : {
        title: 'Este produto não é indicado para o seu perfil de investimento',
        subtitle:
          'Ao continuar, você declara que está ciente e quer investir em um produto fora do nível de risco indicado para o seu perfil.'
      };
});

const buttonLabel = computed(() => {
  return isImpersonate() ? 'Voltar para o catálogo' : 'Continuar';
});

const risks = computed(() => {
  return [
    {
      class: 'low',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value === ERiskGrade.LOW
    },
    {
      class: 'medium',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value ===
        ERiskGrade.MEDIUM
    },
    {
      class: 'high',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value === ERiskGrade.HIGH
    }
  ];
});

const details = computed(() => {
  const risk = {
    label: props.data.requestRisksSignature[0].label,
    value: props.data.requestRisksSignature[0].formatted.formatted
  };

  const list = props.data.customerRiskProfile;
  list.push(risk);

  return list;
});

function handleClick() {
  if (isImpersonate()) {
    router.push({
      name: 'productsCatalog',
      params: {
        type: 'fixed-income'
      }
    });

    return;
  }

  emits('confirm');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,ERiskGrade, router, emits, props, headingData, buttonLabel, risks, details, handleClick, NavBar, HeadingDisplay, Heading, BaseIcon, ListDisplay, ButtonContainer, ButtonPrimary, SideSheet, BackButton }
}

})